import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-labelledby", "aria-describedby"]
const _hoisted_2 = { class: "px-6 py-4 border-b border-gray-200 flex items-center" }
const _hoisted_3 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_4 = {
  key: 0,
  class: "text-yellow-500"
}
const _hoisted_5 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_6 = {
  key: 2,
  class: "text-green-500"
}
const _hoisted_7 = {
  key: 3,
  class: "text-blue-500"
}
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "px-6 py-4" }
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "px-6 py-3 bg-gray-50 flex justify-end space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40 flex items-center justify-center",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleBackdropClick && _ctx.handleBackdropClick(...args))),
          onKeydown: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["esc"])),
          tabindex: "-1"
        }, [
          _createElementVNode("div", {
            class: "bg-white rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
            ref: "modalRef",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _ctx.titleId,
            "aria-describedby": _ctx.messageId
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.showIcon)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_ctx.iconType === 'warning')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[5] || (_cache[5] = [
                          _createElementVNode("svg", {
                            class: "h-6 w-6",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                            })
                          ], -1)
                        ])))
                      : (_ctx.iconType === 'error')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[6] || (_cache[6] = [
                            _createElementVNode("svg", {
                              class: "h-6 w-6",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                              })
                            ], -1)
                          ])))
                        : (_ctx.iconType === 'success')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[7] || (_cache[7] = [
                              _createElementVNode("svg", {
                                class: "h-6 w-6",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M5 13l4 4L19 7"
                                })
                              ], -1)
                            ])))
                          : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[8] || (_cache[8] = [
                              _createElementVNode("svg", {
                                class: "h-6 w-6",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                              ], -1)
                            ])))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("h3", {
                id: _ctx.titleId,
                class: "text-lg font-medium text-gray-900"
              }, _toDisplayString(_ctx.title), 9, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", {
                id: _ctx.messageId,
                class: "text-gray-700"
              }, _toDisplayString(_ctx.message), 9, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["px-4 py-2 rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2", _ctx.cancelButtonClass || 'bg-gray-200 hover:bg-gray-300 text-gray-800 focus:ring-gray-500']),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                ref: "cancelButtonRef"
              }, _toDisplayString(_ctx.cancelButtonText), 3),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["px-4 py-2 rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2", _ctx.confirmButtonClass || 'bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500']),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
              }, _toDisplayString(_ctx.confirmButtonText), 3)
            ])
          ], 8, _hoisted_1)
        ], 32))
      : _createCommentVNode("", true)
  ]))
}